import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ChangeDetectorRef } from '@angular/core';
import { log } from 'console';
import * as XLSX from 'xlsx'; 
@Component({
  selector: 'app-exam-timetable',
  templateUrl: './exam-timetable.component.html',
  styleUrls: ['./exam-timetable.component.scss']
})
export class ExamTimetableComponent implements OnInit {
  ExamTimeTable: FormGroup;
  ExamTTSearchForm;
  ExamList: any;
  examList: any;
  ExamFilterList: any;
  dialogRef: MatDialogRef<any>;
  ExmTimeTable: [];
  ExamArray: FormArray;
  submitpayload: any;
  Time: string;
  Totime: string;
  maxTime: string;
  maxDate: Date;
  date: any;
  holidayDate: any;
  // holidayDates: Date[] = [];
  holidayDates: { FromDate: Date, ToDate: Date, HolidayName: string }[] = [];
  time: any;
  date2: any;
  time2: any;
  SId: any;
  arr
  SessionNo: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  errMsg: any;
  selectedHoliday: any;
  BtnDisable=false;
  examRecords: any;
  fcCodeList: any[] = [];
  filteredListFcCode: any[] = [];
  CourseList: any[] = [];
  filteredListCourse: any[] = [];
  BranchList: any[] = [];
  filteredListBranch: any[] = [];
  BranchShow = false;
  examMasterIdsForCourse: number[] = [];
  examMastersForCourse: any[] = [];
  selectedShift: any = null;
  excelData: any[] = [];
  selectedBranchDetails: any = null;
  sessionList: any[] = [];
  filteredSessionList: any[] = [];

  constructor(public datepipe: DatePipe,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    private router: Router, private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private cdr: ChangeDetectorRef
   ) { }
 
  istableShow = false;
  currentdate: any;
 
  userPermission: any;
  utp: string;
  exTimeUpdate = true;
  exTimeCreate = true;
  ngOnInit(): void {
 

    this.fetchSessionList();



    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Exam-Timetable' && element.PCreate == false) {
          this.exTimeCreate = false;
        }
        if (element.PageName == 'New-Exam-Code' && element.PUpdate == false) {
          this.exTimeUpdate = false;
        }
      });
    }
    window.scroll(0, 0);
    this.istableShow = false;
    this.currentdate = new Date();
    this.maxDate = new Date(3000, 12, 31);
    this.ExamTimeTable = this.fb.group({
      Exam: new FormControl('', Validators.required),
      // Date: new FormControl(''),
      // EtTime: new FormControl(''),
      // EtTimeTo: new FormControl(''),
      // EsId: new FormControl(''),
      // EsName: new FormControl(''),
      // EtSubCode: new FormControl(''),
      // HdCode: new FormControl(''),
      // StrName: new FormControl(''),
      // EsShName: new FormControl(''),
      // StrCode: new FormControl(''),
      // ShId: new FormControl(this.SId),
      CoFcCode: new FormControl(''),
      CoCode: new FormControl(''),
      StrId: new FormControl(''),
      ExamArray: new FormArray([]),
      SessionId: new FormControl('', Validators.required),
    });
    this.getHoliday();
    this.fetchFacultyCode();
  }
 
   // fetchSecretData() {
  //   this.umsService.getSecretData().subscribe((res) => {
  //     this.SessionNo = res.projectPharam['SnNo'];
  //     this.fetchExamSchedule(this.SessionNo);
  //     }
  //   );
  // }
 
  fetchSessionList() {
    this.spinner.show();
    const payload = { SnActive: 'Y' };
    this.umsService.getSession(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.sessionList = res.data || [];
          this.filteredSessionList = [...this.sessionList];
          // Do NOT auto-select – user must choose
        } else {
          this.sessionList = [];
          this.filteredSessionList = [];
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.sessionList = [];
        this.filteredSessionList = [];
      }
    });
  }
  onSessionChange(sessionId: any) {
    this.SessionNo = sessionId;
    this.ExamTimeTable.controls['SessionId'].setValue(sessionId);
    this.resetFormOnSessionChange();
    if (sessionId) {
      this.fetchExamSchedule(sessionId);
    } else {
      this.examList = [];
      this.ExamFilterList = [];
      this.CourseList = [];
      this.filteredListCourse = [];
      this.fcCodeList = [];
      this.filteredListFcCode = [];
      this.BranchList = [];
      this.filteredListBranch = [];
      this.BranchShow = false;
      this.istableShow = false;
    }
  }

  // Helper to reset dependent fields when session changes
  resetFormOnSessionChange() {
    this.ExamTimeTable.patchValue({
      Exam: '',
      CoFcCode: '',
      CoCode: '',
      StrId: '',
    });
    this.istableShow = false;
    this.selectedShift = null;
    this.selectedBranchDetails = null;
    this.excelData = [];
    this.examMasterIdsForCourse = [];
    this.examMastersForCourse = [];
    const examArray = this.ExamTimeTable.get('ExamArray') as FormArray;
    examArray.clear();
  }
 
  fetchFacultyCode() {
    this.umsService.getFaculty({}).subscribe(res => {
      if (res.status) {
        this.fcCodeList = res.data || [];
        this.filteredListFcCode = [...this.fcCodeList];
      }
    });
  }

  onFacultyChange(fcCode: any) {
    // reset dependent dropdowns
    this.ExamTimeTable.patchValue({ CoCode: null, StrId: null, Exam: null });
    this.CourseList = [];
    this.filteredListCourse = [];
    this.BranchList = [];
    this.BranchShow = false;
    this.istableShow = false;
    this.examMasterIdsForCourse = [];
    this.examMastersForCourse = [];
    this.selectedShift = null;
    this.selectedBranchDetails = null;
    if (fcCode) {
      this.getCourse(fcCode);
    }
    this.filterShiftDropdown();
  }

  getCourse(facultyCode) {
    this.spinner.show();
    const payload = { CoFcCode: facultyCode };
    this.umsService.getCourse(payload).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.CourseList = res.data;
          this.filteredListCourse = [...this.CourseList];
        } else {
          this.CourseList = [];
        }
        this.spinner.hide();
      },
      error: () => {
        this.CourseList = [];
        this.spinner.hide();
      }
    });
  }

  onCourseChange(coCode: any) {
    this.ExamTimeTable.patchValue({ StrId: null, Exam: null });
    this.BranchList = [];
    this.BranchShow = false;
    this.istableShow = false;
    this.examMasterIdsForCourse = [];
    this.examMastersForCourse = [];
    this.selectedShift = null;
    this.selectedBranchDetails = null;
    if (coCode) {
      this.spinner.show();
      const payload = { EmCoCode: coCode };
      this.umsService.getExam(payload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res.status && res.data) {
            this.examMasterIdsForCourse = res.data.map(exam => exam.EmId);
            this.examMastersForCourse = res.data;
          } else {
            this.examMasterIdsForCourse = [];
            this.examMastersForCourse = [];
          }
          this.filterShiftDropdown();
        },
        error: () => {
          this.spinner.hide();
          this.examMasterIdsForCourse = [];
          this.examMastersForCourse = [];
          this.filterShiftDropdown();
        }
      });
    } else {
      this.filterShiftDropdown();
    }
  }

  onBranchChange(strId: any) {
    if (!this.selectedShift) return;
    if (strId && strId != 0) {
      this.selectedBranchDetails = this.BranchList.find(b => b.StrId == strId);
    } else {
      this.selectedBranchDetails = null;
    }
     
    this.filterShiftDropdown();
    if (strId && strId != 0) {
      this.getTable(this.selectedShift, strId);
    }
  }

  onExamChange(shId: any) {
    if (!shId) {
      this.istableShow = false;
      this.selectedShift = null;
      this.selectedBranchDetails = null;
      return;
    }

    const selectedShiftObj = this.ExamFilterList.find(shift => shift.ShId == shId);
    if (!selectedShiftObj) return;

    this.selectedShift = selectedShiftObj;

    const examMaster = this.examMastersForCourse.find(em => em.EmId === selectedShiftObj.ShEmId);

    if (examMaster && examMaster.EmStreams == "Y") {
      this.BranchShow = true;
      this.fetchBranch(examMaster.EmId);
      this.istableShow = false; 
    } else {
      this.BranchShow = false;
      this.ExamTimeTable.patchValue({ StrId: 0 });
      this.selectedBranchDetails = null;
      this.getTable(selectedShiftObj);
    }
  }

  filterShiftDropdown() {
  if (!this.examList || this.examList.length === 0) {
    this.ExamFilterList = [];
    return;
  }

  let filtered = [...this.examList];
  if (this.examMasterIdsForCourse && this.examMasterIdsForCourse.length > 0) {
    filtered = filtered.filter(shift =>
      this.examMasterIdsForCourse.includes(shift.ShEmId)
    );
  }

  const selectedStrId = this.ExamTimeTable.get('StrId')?.value;
  if (selectedStrId !== null && selectedStrId !== undefined && selectedStrId !== 0) {
    filtered = filtered.filter(shift => shift.StrId == selectedStrId);
  }
  this.ExamFilterList = filtered;
}

  // Modified to accept session parameter
  fetchExamSchedule(SnNo?) {
    if (!SnNo) {
      SnNo = this.ExamTimeTable.value['SessionId'];
    }
    if (!SnNo) {
      this.examList = [];
      this.ExamFilterList = [];
      return;
    }
    this.spinner.show();
    const payload = {};
    payload['ShSnNo'] = SnNo;
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['ShStatus'] = "";
    this.umsService.getExamSch(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        //this.ExamFilterList = this.examList.slice();
        this.filterShiftDropdown();
      } else {
        this.spinner.hide();
        this.examList = [];
        this.ExamFilterList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.examList = [];
      this.ExamFilterList = [];
    });
  }
  getExamArrayControls() {
    return (this.ExamTimeTable.get('ExamArray') as FormArray).controls;
  }
 
  condition() {
    let payload = this.ExamTimeTable.value
    let arr2 = []
    arr2 = payload.ExamArray
    arr2.forEach(element => {
      if (element.EtTime > element.EtTimeTo) {
        this.ExamTimeTable.get('EtTimeTo').setErrors({
          'SameTimeError': true
        })
      }
      else if (element.EtTime == element.EtTimeTo) {
        this.ExamTimeTable.get('EtTimeTo').setErrors({
          'SameTimeError': true
        })
      }
      else {
        this.ExamTimeTable.controls['EtTimeTo'].setErrors(null)
      }
      if (element.EtTimeTo == '23:59') {
        this.ExamTimeTable.get('EtTimeTo').setErrors({
          'InValidTimeError': true
        })
      }
    });
  }
 
  condition2() {
    let payload = this.ExamTimeTable.value
    let arr2 = []
    arr2 = payload.ExamArray
    arr2.forEach(element => {
      this.ExamTimeTable.controls['EtTimeTo'].setErrors(null)
      if (element.Date < this.currentdate) {
        this.ExamTimeTable.get('Date').setErrors({
          'InValidDate': true
        })
      }
    });
 
 
  }
 
  condition1() {
    let payload = this.ExamTimeTable.value
    let arr2 = []
    arr2 = payload.ExamArray
    arr2.forEach(element => {
      if (element.EtTime == '23:59') {
        this.ExamTimeTable.get('EtTime').setErrors({
          'InValidTimeError': true
        })
      }
    });
  }
 
  addnewdata(e) {
 
    const creds = this.ExamTimeTable.controls.ExamArray as FormArray;
    creds.clear();
    this.excelData = [];
    e.forEach((element, i) => {
      const TentDet = element.TentDet ? new Date(element.TentDet) : null;
      const dateValidator = TentDet ? (control: FormControl) => {
        if (!control.value) return null;
        const selected = new Date(control.value);
        selected.setHours(0,0,0,0);
        const tent = new Date(TentDet);
        tent.setHours(0,0,0,0);
        if (selected < tent) {
          return { dateBeforeTent: true };
        }
        return null;
      } : null;
      this.date = element.EtTime.split('T');
      this.time = this.date[1].split(':00.000Z');
      this.date2 = element.EtTimeTo.split('T');
      this.time2 = this.date2[1].split(':00.000Z');
      // let da = this.date;
      // this.date = this.datepipe.transform(da, 'yyyy-MM-dd');
      const isDefaultDate = element.EtTime === "1900-01-01T00:00:00.000Z";
      const rawDate = (!isDefaultDate && element.EtTime)
        ? new Date(element.EtTime)
        : null;
      this.date = rawDate
        ? this.datepipe.transform(rawDate, 'yyyy-MM-dd')
        : null;

      const branchName = element.StrName || this.selectedBranchDetails?.StrName || '';
      const branchCode = element.StrCode || this.selectedBranchDetails?.StrCode || '';
      
      this.excelData.push({
        Date: this.date,
        FromTime: this.time[0] || '',
        ToTime: this.time2[0] || '',
        Subject: element.EsName || '',
        SubjectCode: element.SubCode || '',
        Head: element.HdCode || '',
        Branch: branchName,
        BranchCode: branchCode
      });

      if (element.EtTime == "1900-01-01T00:00:00.000Z" && element.EtTimeTo == "1900-01-01T00:00:00.000Z") {
        creds.push(
          this.fb.group({
            Date: new FormControl(this.date, [Validators.required,...(dateValidator ? [dateValidator] : [])]),
            EtTime: new FormControl('', [Validators.required]),
            EtTimeTo: new FormControl('', [Validators.required]),
            EsName: new FormControl(element.EsName),
            EtSubCode: new FormControl(element.SubCode),
            HdCode: new FormControl(element.HdCode),
            EsId: new FormControl(element.EsId),
            StrName: new FormControl(element.StrName),
            EsShName: new FormControl(element.EsShName),
            StrCode: new FormControl(element.StrCode),
            ShId: new FormControl(this.SId)
          })
        );
      }
      else {
 
        creds.push(
          this.fb.group({
            Date: new FormControl(this.date, [Validators.required,...(dateValidator ? [dateValidator] : [])]),
            EtTime: new FormControl(this.time[0], [Validators.required]),
            EtTimeTo: new FormControl(this.time2[0], [Validators.required]),
            EsName: new FormControl(element.EsName),
            EtSubCode: new FormControl(element.SubCode),
            HdCode: new FormControl(element.HdCode),
            EsId: new FormControl(element.EsId),
            StrName: new FormControl(element.StrName),
            EsShName: new FormControl(element.EsShName),
            StrCode: new FormControl(element.StrCode),
            ShId: new FormControl(this.SId)
          })
        );
      }
    });
 
  }
 
  addNewRowPrepopulate(e) {
    this.spinner.hide()
    const creds = this.ExamTimeTable.controls.ExamArray as FormArray;
    creds.clear();
    this.excelData = [];
    e.forEach((element, i) => {
      const TentDet = element.TentDet ? new Date(element.TentDet) : null;
      const dateValidator = TentDet ? (control: FormControl) => {
        if (!control.value) return null;
        const selected = new Date(control.value);
        selected.setHours(0,0,0,0);
        const tent = new Date(TentDet);
        tent.setHours(0,0,0,0);
        if (selected < tent) {
          return { dateBeforeTent: true };
        }
        return null;
      } : null;
      this.date = element.EtTime.split('T');
      this.time = this.date[1].split(':00.000Z');
      this.date2 = element.EtTimeTo.split('T');
      this.time2 = this.date2[1].split(':00.000Z');
      // let da = this.date;
      // this.date = this.datepipe.transform(da, 'yyyy-MM-dd');
      const isDefaultDate = element.EtTime === "1900-01-01T00:00:00.000Z";
      const rawDate = (!isDefaultDate && element.EtTime)
        ? new Date(element.EtTime)
        : null;
      this.date = rawDate
        ? this.datepipe.transform(rawDate, 'yyyy-MM-dd')
        : null;
      const branchName = element.StrName || this.selectedBranchDetails?.StrName || '';
      const branchCode = element.StrCode || this.selectedBranchDetails?.StrCode || '';
      
      this.excelData.push({
        Date: this.date,
        FromTime: this.time[0] || '',
        ToTime: this.time2[0] || '',
        Subject: element.EsName || '',
        SubjectCode: element.SubCode || '',
        Head: element.HdCode || '',
        Branch: branchName,
        BranchCode: branchCode
      });

      creds.push(
        this.fb.group({
          Date: new FormControl(this.date, [Validators.required,...(dateValidator ? [dateValidator] : [])]),
          EtTime: new FormControl('', [Validators.required]),
          EtTimeTo: new FormControl('', [Validators.required]),
          EsName: new FormControl(element.EsName),
          EtSubCode: new FormControl(element.SubCode),
          HdCode: new FormControl(element.HdCode),
          EsId: new FormControl(element.EsId),
          StrName: new FormControl(element.StrName),
          EsShName: new FormControl(element.EsShName),
          StrCode: new FormControl(element.StrCode),
          ShId: new FormControl(this.SId)
        })
      );
    });
  }
 
  checkToTime(e): ValidatorFn {
    return (control: FormControl): { [key: string]: any } | null => {
      let payload = this.ExamTimeTable.value;
      if (payload.ExamArray[e]) {
        const EtTime = payload.ExamArray[e]['EtTime'];
        const EtTimeTo = control.value;
        if (EtTime > EtTimeTo) {
          return { 'toTimeBeforeFromTime': true };
        } else if (EtTime < EtTimeTo) {
          return { 'fromTimeBeforetoTime': true };
        }
        else if (EtTime == EtTimeTo) {
          return { 'SameTime': true }
        }
        return null;
      };
    }
 
  }
  // checkTime(e): ValidatorFn {
  //   return (control: FormControl): { [key: string]: any } | null => {
  //      let payload = this.ExamTimeTable.value
  //       if(payload.ExamArray[e]){
  //        const EtTimeTo =  payload.ExamArray[e]['EtTimeTo'];
  //        const EtTime = control.value;
  //         if (EtTimeTo < EtTime) {
  //         return { 'toTimeBeforeFromTime': true };
  //         }
  //         return null;
  //         };
  //       }
  //  }
  checkvalidation(e) {
    return e.controls['EtTimeTo'].touched && e.controls['EtTimeTo'].errors?.toTimeBeforeFromTime;
  }
  checkvalidationtime(e) {
    return e.controls['EtTime'].touched && e.controls['EtTime'].errors?.toTimeBeforeFromTime;
  }
  checkvalidation1(e) {
    return e.controls['EtTimeTo'].touched && e.controls['EtTimeTo'].errors?.SameTime;
  }
  checkvalidationtime1(e) {
    return e.controls['EtTime'].touched && e.controls['EtTime'].errors?.SameTime;
  }
 getTable(item, branchId?: any) {
  this.ExamList = [];
  this.istableShow = true;

  const payload: any = {};
  payload['ShId'] = item.ShId;

  const currentBranch = this.ExamTimeTable.get('StrId').value;
  payload['StrId'] = (branchId !== undefined && branchId !== null)
    ? branchId
    : (currentBranch !== undefined && currentBranch !== null ? currentBranch : 0);

    this.SId = item.ShId;
    this.selectedShift = item;
       // Store branch details when branch is selected
    if (payload['StrId'] && payload['StrId'] != 0) {
      this.selectedBranchDetails = this.BranchList.find(b => b.StrId == payload['StrId']);
    } else {
      this.selectedBranchDetails = null;
    }
  if (item.ShStatus == 'U') {
    this.BtnDisable = true;
  } else {
    this.BtnDisable = false;
  }
  const examMaster = this.examMastersForCourse.find(em => em.EmId === item.ShEmId);
  if (examMaster && examMaster.EmStreams == "Y") {
    this.BranchShow = true;
    this.fetchBranch(examMaster.EmId);
  } else {
    this.BranchShow = false;
    this.ExamTimeTable.patchValue({ StrId: 0 });
  }

  this.getCenterAllocation(item.ShId);

  this.umsService.getExamTT(payload).subscribe(
    res => {
      this.ExamList = res.data;
      this.addnewdata(this.ExamList);
    },
    (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
  );
}

  getTable2(item) {
    this.ExamList = [];
    this.istableShow = true;
    const payload = {};
    payload['ShId'] = item;
    payload['StrId'] = this.ExamTimeTable.get('StrId').value || 0;
// if(item.ShStatus == 'U'){
//       this.BtnDisable = true;
//     }else{
//       this.BtnDisable = false;
//     }
    this.BtnDisable = false;
    
    this.getCenterAllocation(item);
    this.umsService.getExamTT(payload).subscribe(res => {
      this.ExamList = res.data;
      this.addnewdata(this.ExamList);
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  fetchBranch(emId) {
    console.log('Fetching branch for EmId:', emId);
    const payload = { EmId: emId };
    this.umsService.getExamStream(payload).subscribe({
      next: (res) => {
        console.log('Branch API response:', res);
        if (res.status) {
          this.BranchList = res.data;
          this.filteredListBranch = [...this.BranchList];
          this.BranchShow = true;
        } else {
          this.BranchShow = false;
        }
      },
      error: (err) => console.error('Branch fetch error:', err)
    });
  }
 
  submit() {
    this.spinner.show();
    this.submitpayload = this.ExamTimeTable.value;
    let arr = [];
    arr = this.submitpayload.ExamArray
    let iserror = false;
    // payload['SnNo'] = this.SessionNo;
    var bar = new Promise<void>((resolve, reject) => {
      arr.forEach((element, index, array) => {
        let da = element.Date;
        element.Date = this.datepipe.transform(da, 'yyyy-MM-dd');
        this.Time = element.Date + 'T' + element.EtTime + ':00.000Z'
        this.Totime = element.Date + 'T' + element.EtTimeTo + ':00.000Z'
        element.EtTime = this.Time;
        element.EtTimeTo = this.Totime;
        // element.SnNo = this.SessionNo;
        let arr1 = [];
        this.umsService.submitExamTT(element).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            this.spinner.hide();
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            this.spinner.hide();
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        this.spinner.hide();
        let data = {};
        data['message'] = "Submitted Successfully";
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.getTable2(this.ExamTimeTable.value.Exam);
      } else {
        this.spinner.hide();
        let data = {};
        data['message'] = this.errMsg;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
 
      }
    });
  }
 
  print() {
    let submitpayload = this.ExamTimeTable.value;
 
    let payload1 = {}
    payload1['MenuName'] = 'ExamTimeTable';
    payload1['ShId'] = submitpayload.Exam
 
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 124,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }
 
    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }
  exportToExcel() {
    if (!this.excelData || this.excelData.length === 0) {
      let data = {};
      data['message'] = 'No data available to export. Please load exam timetable first.';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-info-circle';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      return;
    }

    this.spinner.show();

    try {
      // Prepare data for Excel with proper headers including Branch Code
      const excelRows = this.excelData.map(item => ({
        'Date': item.Date || '',
        'From Time': item.FromTime || '',
        'To Time': item.ToTime || '',
        'Subject': item.Subject || '',
        'Subject Code': item.SubjectCode || '',
        'Head': item.Head || '',
        'Branch Code': item.BranchCode || '',
        'Branch': item.Branch || ''
      }));

      // Generate file name with course, exam name and branch
      const fileName = this.generateExcelFileName();

      // Create worksheet
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelRows);

      // Set column widths
      ws['!cols'] = [
        { wch: 15 },  // Date
        { wch: 12 },  // From Time
        { wch: 12 },  // To Time
        { wch: 40 },  // Subject
        { wch: 15 },  // Subject Code
        { wch: 20 },  // Head
        { wch: 15 },  // Branch Code
        { wch: 30 }   // Branch
      ];

      // Create workbook
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Exam Timetable');

      // Generate Excel file
      XLSX.writeFile(wb, fileName);

      this.spinner.hide();

      // Show success message
      let data = {};
      data['message'] = `Excel file "${fileName}" downloaded successfully.`;
      data['title'] = 'Success';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    } catch (error) {
      this.spinner.hide();
      console.error('Error exporting to Excel:', error);
      let data = {};
      data['message'] = 'Error exporting to Excel. Please try again.';
      data['title'] = 'Error';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    }
  }

  generateExcelFileName(): string {
    // Get course name
    const coCode = this.ExamTimeTable.get('CoCode')?.value;
    const course = this.CourseList.find(c => c.CoCode == coCode);
    const courseName = course ? `${course.CoCode}-${course.CoName}` : 'Course';

    // Get exam name
    const examName = this.selectedShift ? this.selectedShift.EmShName || 'Exam' : 'Exam';

    // Get branch details
    const strId = this.ExamTimeTable.get('StrId')?.value;
    let branchPart = '';
    
    if (strId && strId != 0) {
      // Try to get branch from BranchList
      const branch = this.BranchList.find(b => b.StrId == strId);
      if (branch) {
        branchPart = `-${branch.StrCode}`;
      } else if (this.selectedBranchDetails) {
        // Fallback to stored branch details
        branchPart = `-${this.selectedBranchDetails.StrCode}`;
      }
    }

    // Clean the names to be filesystem safe
    const cleanCourseName = this.sanitizeFileName(courseName);
    const cleanExamName = this.sanitizeFileName(examName);
    const cleanBranchPart = this.sanitizeFileName(branchPart);

    // Generate timestamp
    const timestamp = this.datepipe.transform(new Date(), 'yyyy-MM-dd');

    // Create file name: CourseCode-CourseName-ExamName-BranchCode_Date.xlsx
    return `${cleanCourseName}-${cleanExamName}${cleanBranchPart}_${timestamp}.xlsx`;
  }

  sanitizeFileName(name: string): string {
    if (!name) return '';
    // Remove invalid characters for Windows/Linux/Mac file names
    return name
      .replace(/[<>:"/\\|?*]/g, '') // Remove invalid characters
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/--+/g, '-') // Replace multiple hyphens with single
      .trim(); // Trim whitespace
  }

  getCourseName(): string {
    const coCode = this.ExamTimeTable.get('CoCode')?.value;
    const course = this.CourseList.find(c => c.CoCode == coCode);
    return course ? `${course.CoCode} - ${course.CoName}` : '';
  }

  getFacultyName(): string {
    const fcCode = this.ExamTimeTable.get('CoFcCode')?.value;
    const faculty = this.fcCodeList.find(f => f.FcCode == fcCode);
    return faculty ? `${faculty.FcCode} - ${faculty.FcDesc}` : '';
  }

  getBranchName(): string {
    const strId = this.ExamTimeTable.get('StrId')?.value;
    const branch = this.BranchList.find(b => b.StrId == strId);
    return branch ? `${branch.StrCode} - ${branch.StrName}` : '';
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
 
  timeValidation(e, i) {
    this.arr = this.ExamTimeTable.controls.ExamArray.value
    let fromTime = e.value.EtTime;
    let toTime = e.value.EtTimeTo;
    if (e.value.Date == '') {
      let data = {}
      data['message'] = 'Select First Date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('EtTime').setValue('');
    }
 
 
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    let previousTime = taskListArrays.controls[i - 1].value['EtTime']
    let currentRowTime = taskListArrays.controls[i].value['EtTime'];
    let previousDate = taskListArrays.controls[i - 1].value['Date']
    let currentRowDate = taskListArrays.controls[i].value['Date'];
    let previousToTime = taskListArrays.controls[i - 1].value['EtTimeTo']
 
    if (previousTime == currentRowTime && previousDate == currentRowDate) {
      let data = {}
      data['message'] = 'Time selected'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
 
    }
 
    this.arr.forEach(element => {
 
      if (toTime != "00:00" && toTime != '' && fromTime >= toTime && element.EtTime != '' && element.EtTimeTo != '') {
        let data = {}
        data['message'] = 'From Time Is Not Greater Than To Time'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
        this.arr.at(i).get('EtTime').setValue('');
      }
      else if (i !== 0 && e.value.Date == element.Date && previousTime == currentRowTime && element.Date != '') {
        let data = {}
        data['message'] = 'Date And Time selected'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
        this.arr.at(i).get('EtTime').setValue('');
      }
      else if (i !== 0 && previousDate == currentRowDate && currentRowTime <= previousToTime) {
        let data = {}
        data['message'] = 'Time Is Invalid'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
        this.arr.at(i).get('EtTime').setValue('');
      }
    })
 
  }
 
 
 
  timeValidation2(e, i) {
    let fromTime = e.value.EtTime;
    let toTime = e.value.EtTimeTo;
    if (fromTime == '' || e.value.Date == '') {
      let data = {}
      data['message'] = 'First Select Date And From Time'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.ExamTimeTable.controls['SearchString'].setValue('');
      // let arr = [];
      // arr = this.submitpayload.ExamArray
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('EtTimeTo').setValue('');
    }
    else if (fromTime = '') {
      let data = {}
      data['message'] = 'First Select From Time'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.ExamTimeTable.controls['SearchString'].setValue('');
      // let arr = [];
      // arr = this.submitpayload.ExamArray
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('EtTimeTo').setValue('');
    }
    else if (e.value.EtTime >= e.value.EtTimeTo) {
      let data = {}
      data['message'] = 'To Date Is Not Less Than From Date'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.ExamTimeTable.controls['SearchString'].setValue('');
      // let arr = [];
      // arr = this.submitpayload.ExamArray
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('EtTimeTo').setValue('');
    }
  }
 
 
  onDateClick(e, i) {
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    let previousfromTime = taskListArrays.controls[i - 1].value['EtTime']
    let previousToTime = taskListArrays.controls[i].value['EtTimeTo'];
    let previousDate = taskListArrays.controls[i - 1].value['Date']
    if (i !== 0 && previousfromTime == '' || previousToTime == '' || previousDate == '') {
      let data = {}
      data['message'] = 'First Select Previous Date And Time'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('Date').setValue('');
    }
  }
 
 
  save() {
    this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
    if (this.ExamTimeTable.invalid) {
      
      this.ExamTimeTable.get('Exam').markAsTouched();
      this.arr.controls.forEach(element => {
 
        element.get('Date').markAsTouched();
        element.get('EtTime').markAsTouched();
        element.get('EtTimeTo').markAsTouched();
        // element.get('FeeAmount').markAsTouched();
 
      })
    }
    else {
      this.submit()
    }
  }
 
  datechange1(i) {
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    // this.isDatePassed(taskListArrays.controls[i].value['Date'])
    let formattedDate = this.datepipe.transform(taskListArrays.controls[i].value['Date'], 'yyyy-MM-dd');
 
    // if(taskListArrays.controls[i].value['Date'] < this.currentdate || formattedDate < this.currentdate){
    //   taskListArrays.controls[i].get('CutOffDate').setErrors({ TodaydateError: true });
    // }
    // else{
    //   taskListArrays.controls[i].get('CutOffDate').setErrors(null);
    // }
    // let Fromdate = taskListArrays.controls[i].value['CutOffDateFrom']
    // let date = taskListArrays.controls[i].value['CutOffDate']
    // if(date <= Fromdate){
    //   taskListArrays.controls[i].get('CutOffDate').setErrors({ dateError: true });
    //   // this.errorcheckValidator(i)
    // }
    // else{
    //   taskListArrays.controls[i].get('CutOffDate').setErrors(null);
    // }
 
  }
 
 
  isDatePassed(cutOffDate: Date): boolean {
    const todayDate = new Date();
    const cutOff = new Date(cutOffDate);
    todayDate.setHours(0, 0, 0, 0);
    cutOff.setHours(0, 0, 0, 0);
 
    // Check if cutOffDate is greater than today's date or same as today's date
    return cutOff < todayDate;
  }
 
 
  checkValidation(item, index) {
    this.arr = this.ExamTimeTable.controls.ExamArray.value
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    // let previousRowDate= taskListArrays.controls[index - 1].value['Date'];
    // let previousRowFromTime =taskListArrays.controls[index - 1].value['EtTime'];
    // let previousRowToTime=taskListArrays.controls[index - 1].value['EtTimeTo'];
    // // else if (i !== 0 && item.value.Date == element.Date && previousTime == currentRowTime && element.Date != '') {  
    // let currentRowDate = item.value.Date;
    // let currentRowFromTime =item.value.EtTime;
    // let currentRowToTime = item.value.EtTimeTo;
    if (index != 0) {
      if (item.value.Date == '') {
        let data = {}
        data['message'] = 'First Selected date'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
        this.arr.at(index).get('EtTime').setValue('');
      }
      for (let i = index; i >= 0; i--) {
        const currentRow = taskListArrays.controls[i];
        //current
        let currentRowDate = currentRow.value.Date;
        let currentRowFromTime = currentRow.value.EtTime;
        let currentRowToTime = currentRow.value.EtTimeTo
 
        //previ
        let previousRowDate = taskListArrays.controls[i - 1].value['Date'];
        let previousRowFromTime = taskListArrays.controls[i - 1].value['EtTime'];
        let previousRowToTime = taskListArrays.controls[i - 1].value['EtTimeTo'];
        let cDate = this.datepipe.transform(currentRowDate, 'yyyy-MM-dd');
        let pDate = this.datepipe.transform(previousRowDate, 'yyyy-MM-dd');
        // && currentRowFromTime == previousRowFromTime
        if (currentRowFromTime == previousRowFromTime) {
          if (cDate == pDate) {
            let data = {}
            data['message'] = 'Date And Time Selected'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-close'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
            this.arr.at(index).get('EtTime').setValue('');
 
          }
          // else{
          //   let data = {}
          //   data['message'] = 'Date And Time Selected'
          //   data['title'] = 'Information'
          //   data['icon'] = 'fas fa-close'
          //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          //   this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
          //   this.arr.at(index).get('EtTime').setValue('');
          // }
 
        }
        else if (cDate == pDate && currentRowFromTime <= previousRowToTime) {
          let data = {}
          data['message'] = 'Time Invalid'
          data['title'] = 'Information'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
          this.arr.at(index).get('EtTime').setValue('');
 
        }
      }
    }
    else {
      const currentRow = taskListArrays.controls[index];
      //current
      let currentRowDate = item.value.Date;
      let currentRowFromTime = item.value.EtTime;
      let currentRowToTime = item.value.EtTimeTo
 
      if (currentRowDate == '') {
        let data = {}
        data['message'] = 'First Selected date'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
        this.arr.at(index).get('EtTime').setValue('');
      }
    }
 
 
    const filteredElements = this.arr.filter(element => {
      let fromTime = element.EtTime;
      let toTime = element.EtTimeTo
      //  if(currentRowDate == ''){
      //   let data = {}
      //   data['message'] = 'First Selected date'
      //   data['title'] = 'Information'
      //   data['icon'] = 'fas fa-close'
      //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      //   this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      //   this.arr.at(index).get('EtTime').setValue('');
      //  }
      //  else if(index != 0 && currentRowDate == element.Date && currentRowFromTime == element.EtTime){
      //   let data = {}
      //   data['message'] = 'Date And Time Selected'
      //   data['title'] = 'Information'
      //   data['icon'] = 'fas fa-close'
      //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      //   this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      //   this.arr.at(index).get('EtTime').setValue('');
      //  }
    });
  }
 
 
  dateValidation(item, i) {
    this.arr = this.ExamTimeTable.controls.ExamArray.value
    let taskListArrays = this.ExamTimeTable.get('ExamArray') as FormArray;
    let selectedDateControl = taskListArrays.controls[i].get('Date');
    let selectedDate = new Date(selectedDateControl.value);
    // if(taskListArrays.controls[i].value['Date'].getDay() == 0){
    //   let data = {};
    //       data['message'] = 'The Selected Day Is Sunday. Do You Still Want To Proceed?';
    //       data['title'] = 'Alert';
    //       data['icon'] = 'fa fa-question';
    //       this.dialogRef =
    //         this.modalPopupService.openPopup<ConformationModelComponent>(
    //           ConformationModelComponent,
    //           data
    //         );
    //       this.dialogRef.afterClosed().subscribe((result) => {
    //         if (result === 'yes') {
    //           taskListArrays.controls[i].get('Date').setValue(taskListArrays.controls[i].value['Date']);
    //         } else {
    //           taskListArrays.controls[i].get('Date').setValue('');
    //         }
    //       });
    // }


    let isHoliday = this.holidayDates.some(holiday => {
      let FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
      let ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
      let currentDate = selectedDate.setHours(0, 0, 0, 0);
      return currentDate >= FromDate && currentDate <= ToDate;
    });

    if (isHoliday) {
      // Find all holidays that overlap with the selected date
      let overlappingHolidays = this.holidayDates.filter(holiday => {
        let FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
        let ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
        let currentDate = selectedDate.setHours(0, 0, 0, 0);
        return currentDate >= FromDate && currentDate <= ToDate;
      });
  
      // Join holiday names
      let holidayNames = overlappingHolidays.map(holiday => holiday.HolidayName).join(', ');
  
      let data = {
        message: `The Selected Day Is ${holidayNames}. Do You Still Want To Proceed?`,
        title: 'Alert',
        icon: 'fa fa-question'
      };
      this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
      this.dialogRef.afterClosed().subscribe((result) => {
        if (result !== 'yes') {
          selectedDateControl.setValue('');
          // selectedDateControl.markAsUntouched();
        }
      });
    } else {
      selectedDateControl.setValue(selectedDateControl.value);
    }
  
    // if (isHoliday) {
    //   let holiday = this.holidayDates.find(holiday => {
    //     let FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
    //     let ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
    //     let currentDate = selectedDate.setHours(0, 0, 0, 0);
    //     return currentDate >= FromDate && currentDate <= ToDate;
    //   });
  
    //   if (holiday) {
    //     this.selectedHoliday = holiday;
    //     let data = {
    //       message: `The Selected Day Is ${this.selectedHoliday.HolidayName}. Do You Still Want To Proceed?`,
    //       title: 'Alert',
    //       icon: 'fa fa-question'
    //     };
    //     this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    //     this.dialogRef.afterClosed().subscribe((result) => {
    //       if (result !== 'yes') {
    //         selectedDateControl.setValue('');
    //         // selectedDateControl.markAsUntouched();
    //       }
    //     });
    //   }
    // } else {
    //   selectedDateControl.setValue(selectedDateControl.value);
    // }




    let previousRowDate = taskListArrays.controls[i - 1].value['Date'];
    let previousRowFromTime = taskListArrays.controls[i - 1].value['EtTime'];
    let previousRowToTime = taskListArrays.controls[i - 1].value['EtTimeTo'];
    if (i != 0 && (previousRowDate == '' || previousRowFromTime == '' || previousRowToTime == '')) {
      let data = {}
      data['message'] = 'First Select Previous Row Date and Time'
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.arr = this.ExamTimeTable.get('ExamArray') as FormArray
      this.arr.at(i).get('Date').setValue('');
    }
 
  
  }


  getHoliday() {
  const payload = {};
  payload['SnNo'] = '';
    this.umsService.getExamHoliday(payload).subscribe(res => {
      if (res.status) {
        this.holidayDates = res.data.map(item => ({
          FromDate: new Date(item.FromDate),
          ToDate: new Date(item.ToDate),
          HolidayName: item.HolidayName
        }));
        this.cdr.detectChanges(); 
      }
      this.spinner.hide();
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  dateClass = (d: Date | null): string => {
    const date = d || new Date();
    const holiday = this.holidayDates.find(holiday => {
      const FromDate = new Date(holiday.FromDate).setHours(0, 0, 0, 0);
      const ToDate = new Date(holiday.ToDate).setHours(23, 59, 59, 999);
      const currentDate = date.setHours(0, 0, 0, 0);
      return currentDate >= FromDate && currentDate <= ToDate;
    });
    if (holiday) {
      this.selectedHoliday = holiday; 
      return 'holiday-date';
    } else {
      return '';
    }
  }


  getCenterAllocation(ShId){
    this.spinner.show();
    let payload = {};
    payload['EcShId'] = ShId;
    payload['EcInCode'] = 20;
    payload['EcOpId'] = sessionStorage.getItem('userId');
    this.umsService.getSupExamEditRecord(payload).subscribe(
      (res) => {
        this.spinner.hide();
        //any time updated exam time table
//  if (res.status) {
//           this.examRecords = res.data;
//           let allStatusU = true;
//           this.examRecords.forEach(element => {
//             if (element.EcInCode === 20 && element.EcStatus !== "U") {
//               allStatusU = false;
//           }
//           if (allStatusU) {
//             this.BtnDisable = true;
//         } else {
//           this.BtnDisable = false;
//         }
//           });
//         } 
//         else {
       
//         }
      },
      (ERROR: HttpErrorResponse) => {
       
        this.spinner.hide();
      }
    );

  }
}